import {CITY_DOGS, CYCLING, DOGS, HORSES, MARBLES, HORSES_SPRINTS, MOTOR_RACING, VPP_MOTORRACING_STOCKCARS_CHANNEL, VPP_AMERICANFOOTBALL_USLEAGUE_CHANNEL} from '../../../../../constants/identifiers';
import {VPP_MARBLES_EURO} from '../constants/identifiers';

export function hasEventTypeRacerNumberUI(eventType) {
    switch (eventType) {
        case HORSES:
        case HORSES_SPRINTS:
        case CYCLING:
        case MARBLES:
            return true;
        default:
            return false;
    }
}

export function isMarbleEvent(eventType) {
    switch (eventType) {
        case MARBLES:
            return true;
        default:
            return false;
    }
}

export function isMarbleNonEuroEvent(eventType, gameName) {
    return eventType === MARBLES && !gameName.includes(VPP_MARBLES_EURO);
}

export function isMarbleEuroEvent(eventType, gameName) {
    return eventType === MARBLES && gameName.includes(VPP_MARBLES_EURO);
}

export function isDogsEvent(eventType) {
    switch (eventType) {
        case DOGS:
        case CITY_DOGS:
            return true;
        default:
            return false;
    }
}

export function isPlayerStatusIgnore(channel) {
    switch (channel) {
        case VPP_MOTORRACING_STOCKCARS_CHANNEL:
        case VPP_AMERICANFOOTBALL_USLEAGUE_CHANNEL:
            return true;
        default:
            return false;
    }
}




// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/racing/helpers/racersHelper.js